module.exports = __webpack_public_path__ + "img/group-1063.3d3a9544.svg";